module.exports = __webpack_public_path__ + "assets_1789978653902/img/pic_4.427fca0b.png";